export default [{
  path: '/view/companyactivities',
  name: 'companyactivities',
  component: () => import('@/app/company-activities/CompanyActivities'),
  meta: {
    resource: 'companyactivities',
    actions: ['read']
  }
}]
